import Vue from "vue";
import Router from "vue-router";
import PublicLayout from "../layouts/PublicLayout.vue";
import AdminLayout from "../layouts/AdminLayout.vue";
import HomeView from "../views/Home/Index.vue";
import AboutView from "../views/About/Index.vue";
import ContactView from "../views/Contact/Index.vue";
import NewsView from "../views/News/Index.vue";
import NewsDetailView from "../views/NewsDetail/Index.vue";
import AdminLoginView from "../admin-views/Login.vue";
import AdminDashboardView from "../admin-views/Dashboard/Index.vue";
import AdminPostsView from "../admin-views/Posts/Index.vue";
import AdminBannersView from "../admin-views/Banners/Index.vue";
import AdminCompanyInfoView from "../admin-views/CompanyInfo/Index.vue";
import AdminContactsView from "../admin-views/Contacts/Index.vue";
import { setPageSeo } from "../utils/seo";
import { getAuthToken, clearAuth } from "../utils/auth";

Vue.use(Router);

const publicPageSeo = {
  home: {
    title: "NWM Vietnam | Công ty TNHH NWM Việt Nam - Nihon Water Maintenance",
    description: "NWM Vietnam (Nihon Water Maintenance) - Công ty TNHH NWM Việt Nam. Bảo trì, vận hành hệ thống nước và môi trường. Cleaner Water, Bluer Future."
  },
  about: {
    title: "Giới thiệu công ty | NWM Vietnam",
    description: "Công ty TNHH NWM Việt Nam - Nihon Water Maintenance cung cấp giải pháp bảo trì, vận hành và thi công hệ thống nước, môi trường."
  },
  contact: {
    title: "Liên hệ | NWM Vietnam",
    description: "Liên hệ Công ty TNHH NWM Việt Nam để được tư vấn giải pháp bảo trì, vận hành và thi công hệ thống nước, môi trường."
  },
  news: {
    title: "Tin tức ngành nước | NWM Vietnam",
    description: "Tin tức và kiến thức về bảo trì, vận hành, nâng cấp hệ thống nước từ NWM Vietnam - Nihon Water Maintenance."
  },
  "news-detail": {
    title: "Bài viết | NWM Vietnam",
    description: "Bài viết về giải pháp nước, bảo trì và vận hành hệ thống từ NWM Vietnam."
  }
};

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: PublicLayout,
      children: [
        { path: "", name: "home", component: HomeView },
        { path: "about", name: "about", component: AboutView },
        { path: "contact", name: "contact", component: ContactView },
        { path: "news", name: "news", component: NewsView },
        { path: "news/:slug", name: "news-detail", component: NewsDetailView }
      ]
    },
    {
      path: "/admin/login",
      name: "admin-login",
      component: AdminLoginView
    },
    {
      path: "/admin",
      component: AdminLayout,
      meta: { requiresAuth: true },
      children: [
        { path: "", redirect: "/admin/dashboard" },
        { path: "dashboard", name: "admin-dashboard", component: AdminDashboardView },
        { path: "posts", name: "admin-posts", component: AdminPostsView },
        { path: "banners", name: "admin-banners", component: AdminBannersView },
        {
          path: "company-info",
          name: "admin-company-info",
          component: AdminCompanyInfoView
        },
        { path: "contacts", name: "admin-contacts", component: AdminContactsView }
      ]
    }
  ],
  scrollBehavior: function scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeEach(function authGuard(to, from, next) {
  const token = getAuthToken();

  if (to.matched.some(function match(record) {
    return record.meta.requiresAuth;
  })) {
    if (!token) {
      clearAuth();
      return next({ name: "admin-login" });
    }
  }

  if (to.name === "admin-login" && token) {
    return next({ name: "admin-dashboard" });
  }

  return next();
});

router.afterEach(function updatePublicPageSeo(route) {
  const pageSeo = publicPageSeo[route.name];
  if (pageSeo) {
    setPageSeo({
      title: pageSeo.title,
      description: pageSeo.description,
      path: route.path
    });
  }
});

export default router;
